module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAAC8BAMAAABmnfarAAAAElBMVEXe3t7d3d3k5OTe3t4AAADd3d2Y+e3bAAAABXRSTlPmphztAPMTpaIAAABdSURBVGje7dEhAQAgDERRDB6zBDShw/pXIQMTM7zz39wbZ+Xzxs5CFJVotkWRTUeULufEiRMnTpw4ceLEiRMnTpw4ceLEiRMnTpw4ceLEiRMnTpw4ceLEiROnn50usnd630mxYqkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/securities/two.png
// module id = 4XCX
// module chunks = 0